import { img } from "@/lib/images";

const w = (num: string, caption: string, captionEn: string) => ({
  key: `weddings/weddings-gallery/wedding-${num}_full.jpg`,
  thumb: img(`weddings/weddings-gallery/wedding-${num}_thumb.jpg`),
  full: img(`weddings/weddings-gallery/wedding-${num}_full.jpg`),
  caption,
  captionEn,
});

export const weddingGalleryImages = [
  w("01", "Schleier aufstecken", "Putting on the veil"),
  w("38", "Make-up", "Make-up"),
  w("02", "Make-up", "Make-up"),
  w("03", "Bräutigam macht sich fertig", "Groom getting ready"),
  w("04", "Orchideen Brautstrauß", "Orchid bridal bouquet"),
  w("05", "Frangipani Brautstrauß", "Frangipani bridal bouquet"),
  w("06", "Foto Shooting vor der Trauung", "Photo shoot before the ceremony"),
  w("07", "Braut mit Blumenmädchen", "Bride with flower girls"),
  w("39", "Braut mit Blumenmädchen", "Bride with flower girls"),
  w("08", "Brautführerinnen", "Bridesmaids"),
  w("09", "Hochzeitszeremonie", "Wedding ceremony"),
  w("10", "Hochzeitszeremonie", "Wedding ceremony"),
  w("11", "Glückliches Paar", "Happy couple"),
  w("12", "Foto Shooting", "Photo shoot"),
  w("13", "Foto Shooting", "Photo shoot"),
  w("14", "Traditionelle Balitracht", "Traditional Balinese attire"),
  w("15", "Traditionelle Balitracht", "Traditional Balinese attire"),
  w("16", "Königliche Hochzeitstracht", "Royal wedding attire"),
  w("17", "Blumenschale für Ringe", "Flower bowl for the rings"),
  w("18", "Blumenschale für Ringe", "Flower bowl for the rings"),
  w("19", "Hochzeitstorte", "Wedding cake"),
  w("20", "Sekt zum Anstoßen", "Sparkling wine for the toast"),
  w("21", "Anstoßen mit dem Paar", "Toast with the couple"),
  w("22", "Foto Shooting im Garten", "Photo shoot in the garden"),
  w("35", "Blumenstreuen", "Scattering flowers"),
  w("24", "Foto Shooting", "Photo shoot"),
  w("25", "Foto Shooting im Reisfeld", "Photo shoot in the rice field"),
  w("37", "Let's go...", "Let's go..."),
  w("26", "Los gehts...", "Here we go..."),
  w("27", "Foto Shooting am Strand", "Photo shoot on the beach"),
  w("28", "Foto Shooting am Strand", "Photo shoot on the beach"),
  w("29", "Foto Shooting am Strand", "Photo shoot on the beach"),
  w("30", "Foto Shooting am Strand", "Photo shoot on the beach"),
  w("31", "Foto Shooting am Strand", "Photo shoot on the beach"),
  w("32", "Candlelight-Dinner", "Candlelight-Dinner"),
  w("33", "Candlelight-Dinner", "Candlelight-Dinner"),
];